import React, { Component, useState, useEffect } from 'react';
import authService from './api-authorization/AuthorizeService'
import { Route, Link } from "react-router-dom";
import MyModal from "../components/MyModal";
import LinkButton from '../components/LinkButton';
import * as $ from 'jquery'
import * as MySound from '../components/MySound';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../components/GlobalContext';

export const LoadPallet = (props) => {
    const [state, setState] = useState(reset());
    let txtID = null;

    function reset(saveState) {
        let defaultState = { palletID: "", cartonID: "", headerTitle: "Scan Pallet ID", sending: false };
        if (saveState)
            setState(defaultState);
        else
            return defaultState;
    }
    useEffect(() => {
        txtID.focus();
    });
    function txtKeyPressed(e) {
        if (e?.which == 13) {
            let $target = $(e.currentTarget);
            let value = $target.val();
            var newState = { ...state };
            if (newState.palletID == "") {
                newState.palletID = value;
                newState.headerTitle = "Scan Carton ID";
                MySound.play(MySound.Sound.next);
            } else {
                newState.cartonID = value;
                newState.headerTitle = MyGlobal.strings.sending;
                newState.sending = true;
            }
            $target.val("");
            setState(newState);
        }
    }


    async function SendPalletLoad () {
        //   const token = await authService.getAccessToken();
        let userID = MyGlobal.user;
        let url = `api/Tote/ClientMovePalletLoad?cartonID=${state.cartonID}&palletID=${state.palletID}&userID=${userID}`;

        const response = await fetch(url, {
        //      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (data.length > 0) {
            MySound.play(MySound.Sound.next);
        } else {
            MySound.play(MySound.Sound.stop);
        }
        reset(true);
    }

    if (state.sending)
        SendPalletLoad();

    document.title = MyGlobal.pageTitle = "SCSPDA App";
    return (<div className="container">
        <MyHeading>{state.headerTitle}</MyHeading>
        <div className="form-group">
            <div className="input-group">
                <input className="form-control"
                    type="text"
                    onKeyPress={(e) => {
                        txtKeyPressed(e);
                    }}
                    readOnly={state.sending}
                    name="txtID"
                    id="txtID"
                    autoFocus
                    ref={(input) => { txtID = input; }}
                />

            </div>
        </div>
        <div className={state.palletID == "" ? "d-none" : "form-group "}  >
            <div className="form-text" >Scanned Pallet ID</div>
            <label className="form-label">{state.palletID}</label>
        </div>
        <div className={state.cartonID == "" ? "d-none" : "form-group "}  >
            <div className="form-text" >Scanned Carton ID</div>
            <label className="form-label">{state.cartonID}</label>
        </div>
        <button className="btn btn-success col-12 mb-2" disabled={state.sending} onClick={() => { reset(true); }}>Refresh</button>
    </div>)


}
